// @ts-nocheck
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  PageHeader,
  Row,
  Select,
  Spin,
  Table,
  Tag,
} from 'antd';
import { Content } from 'antd/es/layout/layout';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

import { useRequest } from '../../utils/hooks/requestHook';

const { Option } = Select;

export const CreateInviteCode: React.FC<any> = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState([]);
  const [groups, setGroups] = useState([]);
  const [isEditModalVisible, setIsEditModalVisible] = useState(false);
  const [editingInvite, setEditingInvite] = useState<any>(null);
  const { get, post, put, deleteRequest } = useRequest();

  const fetchStaticInviteCodes = async () => {
    setLoading(true);
    try {
      const response = await get('/Invite/GetStaticInvitationCodeList');
      if (response?.data) {
        setData(response.data);
      } else {
        throw new Error('No data received');
      }
    } catch (error) {
      console.error('Error fetching invite codes:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchGroups = async () => {
    try {
      const response = await get('/Group/GetAllGroups');
      if (response?.data) {
        setGroups(response.data);
      }
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  };

  useEffect(() => {
    fetchStaticInviteCodes();
    fetchGroups();
  }, []);

  const handleAddInviteCode = async (values: any) => {
    setLoading(true);
    try {
      const newInviteCode = {
        groupId: values.groupId || null,
        invitationCode: values.invitationCode,
        expired: false,
        maxUsageCount: values.maxUsageCount || 100,
      };
      const response = await post(
        '/Invite/AddStaticInvitationCode',
        newInviteCode
      );

      if (response?.data) {
        notification.success({
          message: 'Success',
          description: 'Static invite code added successfully!',
        });
        fetchStaticInviteCodes();
      } else {
        throw new Error('Failed to add invite code');
      }
    } catch (error: any) {
      console.error('Error adding invite code:', error);
      notification.error({
        message: 'Error',
        description:
          error?.response?.data?.message || 'Failed to add invite code.',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveInviteCode = async (id: number) => {
    Modal.confirm({
      title: 'Are you sure?',
      content: `Do you really want to remove the invite code with ID: ${id}? This action cannot be undone.`,
      okText: 'Yes, Remove',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: async () => {
        setLoading(true);
        try {
          const url = `/Invite/DeleteStaticInvitationCode?id=${id}`;
          const response = await deleteRequest(url);
          notification.success({
            message: 'Success',
            description: 'Static invite code removed successfully!',
          });
          fetchStaticInviteCodes();
        } catch (error: any) {
          console.error('Error removing invite code:', error.response || error);
          notification.error({
            message: 'Error',
            description:
              error.response?.data?.message ||
              'Failed to remove static invite code.',
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const handleEditInviteCode = (record: any) => {
    setEditingInvite(record);
    setIsEditModalVisible(true);
  };

  const handleUpdateInviteCode = async (values: any) => {
    setLoading(true);
    try {
      const updatedInviteCode = {
        ...editingInvite,
        ...values,
      };

      const response = await put(
        '/Invite/UpdateStaticInvitationCode',
        updatedInviteCode
      );

      if (response?.status === 200 || response?.ok) {
        notification.success({
          message: 'Success',
          description: 'Invite code updated successfully!',
        });
        fetchStaticInviteCodes();
        setIsEditModalVisible(false);
      } else {
        throw new Error('Failed to update invite code');
      }
    } catch (error: any) {
      console.error('Error updating invite code:', error);
      notification.error({
        message: 'Error',
        description:
          error?.response?.data?.message || 'Failed to update invite code.',
      });
    } finally {
      setLoading(false);
    }
  };

  const tableColumns = [
    {
      title: 'Id',
      width: 30,
      dataIndex: 'id',
      render: (id: number) => (
        <Tag key={`row_id_${id}`} color="#108ee9">
          #{id}
        </Tag>
      ),
    },
    {
      title: 'Invite Code',
      dataIndex: 'invitationCode',
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: 'Group',
      dataIndex: 'groupId',
      render: (groupId: number | null) => {
        if (!groupId) return '-';
        const group = groups.find((g) => g.id === groupId);
        return group ? group.name : `Group #${groupId}`;
      },
    },
    {
      title: 'Max Usage Count',
      dataIndex: 'maxUsageCount',
      render: (count: number) => <div>{count}</div>,
    },
    {
      title: 'Created On',
      dataIndex: 'createdOnUtc',
      render: (date: string) => <div>{new Date(date).toLocaleString()}</div>,
    },

    {
      title: 'Actions',
      width: 120,
      render: (_: any, record: any) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Button type="primary" onClick={() => handleEditInviteCode(record)}>
            Edit
          </Button>
          <Button danger onClick={() => handleRemoveInviteCode(record.id)}>
            Remove
          </Button>
        </div>
      ),
    },
  ];

  const groupSelect = (
    <Select
      showSearch
      allowClear
      placeholder="Select a group"
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.children as string)
          ?.toLowerCase()
          .includes(input.toLowerCase())
      }
    >
      {groups.map((group) => (
        <Option key={group.id} value={group.id}>
          {group.name}
        </Option>
      ))}
    </Select>
  );

  return (
    <div>
      <PageHeader
        className="site-page-header"
        onBack={() => null}
        title="Create Invite Code"
      />
      <Content style={{ margin: '0px 16px 0', overflow: 'initial' }}>
        <div
          className="site-layout-background"
          style={{ padding: 24, textAlign: 'center' }}
        >
          <Spin spinning={loading}>
            <Form onFinish={handleAddInviteCode} layout="vertical">
              <Form.Item label="Group" name="groupId">
                {groupSelect}
              </Form.Item>
              <Form.Item
                label="Invite Code"
                name="invitationCode"
                rules={[
                  { required: true, message: 'Please input Invite Code!' },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="Max Usage Count"
                name="maxUsageCount"
                rules={[
                  { required: true, message: 'Please input max usage count!' },
                ]}
              >
                <Input type="number" />
              </Form.Item>
              <Button type="primary" htmlType="submit">
                Add New Static Invite Code
              </Button>
            </Form>
          </Spin>
        </div>
      </Content>
      <Content style={{ margin: '0px 16px 0', overflow: 'initial' }}>
        <div
          className="site-layout-background"
          style={{ padding: 24, textAlign: 'center' }}
        >
          <Spin spinning={loading}>
            <Table
              columns={tableColumns}
              dataSource={
                Array.isArray(data) ? data.map((item) => ({ ...item })) : []
              }
              pagination={false}
              rowKey="id"
            />
          </Spin>
        </div>
      </Content>
      <Modal
        title="Edit Invite Code"
        visible={isEditModalVisible}
        onCancel={() => setIsEditModalVisible(false)}
        footer={null}
      >
        <Form
          initialValues={editingInvite}
          onFinish={handleUpdateInviteCode}
          layout="vertical"
        >
          <Form.Item label="Group" name="groupId">
            {groupSelect}
          </Form.Item>
          <Form.Item label="Invite Code" name="invitationCode">
            <Input />
          </Form.Item>
          <Form.Item label="Max Usage Count" name="maxUsageCount">
            <Input type="number" />
          </Form.Item>
          <Button type="primary" htmlType="submit">
            Update Invite Code
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
